<template>
    <div class="l-auth">
        <slot />

        <y-loading
            :active="$wait.is('loading-page')"
            height="100vh"
            size="50px"
        />
    </div>
</template>

<script>
    export default {
        name: 'AuthLayout',
    };
</script>

